var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-btn",class:{
      'step-btn--prev': _vm.type == 'prev',
      'step-btn--next': _vm.type == 'next',
      'step-btn--active': _vm.isActive
  },on:{"click":_vm.handleClick}},[_c('div',{staticClass:"step-btn-inner"},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-0ba67b38","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/pages/fundingnew/components/StepBtn.vue
// module id = null
// module chunks = 